import { render, staticRenderFns } from "./WorkSchedule-comp.vue?vue&type=template&id=64f807a4&"
import script from "./WorkSchedule-comp.vue?vue&type=script&lang=js&"
export * from "./WorkSchedule-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports